module.exports = __webpack_public_path__ + "img/image3.166e3190.png";